import { render, staticRenderFns } from "./trainingCreate.vue?vue&type=template&id=b81ed400&scoped=true"
import script from "./trainingCreate.vue?vue&type=script&lang=js"
export * from "./trainingCreate.vue?vue&type=script&lang=js"
import style0 from "./trainingCreate.vue?vue&type=style&index=0&id=b81ed400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81ed400",
  null
  
)

export default component.exports